import React from "react";
import {
  MapPin,
  Phone,
  Mail,
  MessageCircle,
  Printer,
} from "lucide-react";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-container">

        <div className="footer-grid container">
<div className="row">
          {/* COMPANY */}
          <div className="col-md-4">
          <div className="footer-column">
            <h4>JTM Trading</h4>

            <p className="footer-description">
              Come and visit our store located in Addis Ababa, Ethiopia
              and choose your favorite motorcycle, three-wheelers or Qute.
            </p>

            <div className="footer-socials">
<a
  href="https://www.facebook.com/jtmbajaj/"
  target="_blank"
  rel="noreferrer"
  aria-label="Facebook"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.099 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.413c0-3.017 1.792-4.685 4.533-4.685 1.312 0 2.686.236 2.686.236v2.976h-1.514c-1.491 0-1.956.93-1.956 1.885v2.262h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.099 24 12.073z" />
  </svg>
</a>
{" "}
              <a
                href="https://m.me/jtmbajaj"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook Messenger"
              >
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

</div>
<div className="col-md-4">
          {/* CONTACT 1 */}
          <div className="footer-column">
            <h4>Contact #1</h4>

            <div className="footer-contact-item">
              
              <p>
                <MapPin size={19} /> Kirkos Shop Center C-007 & C-009,
                <br />
                Addis Ababa, Ethiopia
              </p>
            </div>

<p>            <a
              href="tel:+251911723558"
              className="footer-contact-item footer-link"
            >
              <Phone size={18} /> <span>+251 911 72 35 58</span>
            </a>
</p>
<p>
            <a
              href="tel:+251911223580"
              className="footer-contact-item footer-link"
            >
              <Phone size={18} /> <span>+251 911 22 35 80</span>
            </a>
</p>
<p>
            <a
              href="tel:+251924878787"
              className="footer-contact-item footer-link"
            >
              <Phone size={18} />
              <span>+251 924 87 87 87</span>
            </a>
</p>
<p>
            <a
              href="mailto:jtmtrading20@gmail.com"
              className="footer-contact-item footer-link"
            >
              <Mail size={18} /> <span>jtmtrading20@gmail.com</span>
            </a>

            </p>

            <p>
            <a
              href="mailto:inbox@jtmbajaj.com"
              className="footer-contact-item footer-link"
            >
              <Mail size={18} /> <span>inbox@jtmbajaj.com</span>
            </a>

            </p>
          </div>
          </div>

<div className="col-md-4">
          {/* CONTACT 2 */}
          <div className="footer-column">
            <h4>Contact #2</h4>

            <div className="footer-contact-item">
              
              <p>
                <MapPin size={19} /> Bethel around CBE Bethel Mariam Branch,
                <br />
                Addis Ababa, Ethiopia
              </p>
            </div>
<p>
            <a
              href="tel:+251911223592"
              className="footer-contact-item footer-link"
            >
              <Phone size={18} /> <span>+251 911 22 35 92</span>
            </a>
</p>
<p>
            <a
              href="tel:+251931878787"
              className="footer-contact-item footer-link"
            >
              <Phone size={18} /> <span>+251 931 87 87 87</span>
            </a>
            </p>

            <div className="footer-contact-item">
              <Printer size={18} /> <span>+251 11 470 3154</span>
            </div>
          </div>
           <div className="footer-bottom mt-2">
          <p>
            Copyright © 2018-2022 JTM Trading. All rights reserved.
          </p>
        </div>

        </div>

</div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;